import { call, put, takeEvery } from 'redux-saga/effects';
import {
  bigCommerceActionCreators,
  BigCommerceApiKeys,
  IBigCommerceShipTypeMap,
  UpdateBigCommerceShipMethod
} from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../bigCommerceApi';

function* updateBigCommerceShipMethods(action: UpdateBigCommerceShipMethod) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<IEntityWithMessages<IBigCommerceShipTypeMap>> = yield call(
    api.updateBigCommerceShipMethod,
    action.payload
  );

  if (!response.requestFailed && response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(bigCommerceActionCreators.setShipMethods([response.value.value]));
    }
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateBigCommerceShipMethods() {
  yield takeEvery(BigCommerceApiKeys.UPDATE_BIG_COMMERCE_SHIP_METHOD, updateBigCommerceShipMethods);
}
